export default {
  outlined: {
    marginRight: 5,
    marginBottom: 5
  }
};
